import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { StorageModule } from "@ngx-pwa/local-storage";
import { NgxPermissionsModule } from "ngx-permissions";
import { HttpErrorInterceptor } from "./interceptors/http.interceptor";
import { LoggingInterceptor } from "./interceptors/logging.interceptor";

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		StorageModule,
		RouterModule,
		NgxPermissionsModule.forRoot(),
	],
	exports: [NgxPermissionsModule,CommonModule],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
	],
})
export class CoreModule {}
